import store from 'store2'

import documentInsert from './documentInsert'

export default function(o){

  if(o.store("userMarkers")){

    var userMarkers = o.store("userMarkers")

    for (var i = 0; i < userMarkers.length; i++) {

      var data = o.data.userMarkers
      var collection = 'userMarkers'

      var item = userMarkers[i]

      item.date = item.undefined
      item.user = o.store('email')
      item.migrated = true
      delete item.undefined
      delete item._id

      documentInsert(o,data,item,collection,function(){
        console.log('userMarker migratred', item);
      })

      o.store.remove('userMarkers')

    }

  }

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/migrateUserMarkers.js